__turbopack_context__.v({
  "clamp": "FOAy3G_clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "h1": "FOAy3G_h1",
  "h2": "FOAy3G_h2",
  "h3": "FOAy3G_h3",
  "h4": "FOAy3G_h4",
  "h5": "FOAy3G_h5",
  "h6": "FOAy3G_h6",
  "root": "FOAy3G_root",
  "shadow": "FOAy3G_shadow",
});
